var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tooltip',{attrs:{"label":_vm.$t('dict.edit')}},[_c('span',{staticClass:"AEditIcon",on:{"click":function($event){return _vm.$emit('click')}}},[_c('edit2-icon',{attrs:{"size":"16"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }